import './App.css'

import { ToasterComponent } from './features/toaster/ui/ToasterComponent'
import PlinkoLand from './components/plinko-land/PlinkoLand'
import PixelScripts from './components/PixelScripts'

function App() {
    return (
        <div>
            <PixelScripts />
            <PlinkoLand />
            <div id="modals" />
            <ToasterComponent />
        </div>
    )
}

export default App
